import script from "./AccountList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountList.vue?vue&type=script&setup=true&lang=ts"

import "./AccountList.vue?vue&type=style&index=0&id=043c07fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043c07fe"]])

export default __exports__